export default __webpack_public_path__ + "assets/icon-date.f7f9ff78.webp";